<template>
    <div class="layout-sent">
      <transition enter-active-class="animated zoomIn" leave-active-class="animated zoomOut">
        <div class="window ui-scroll" :class="[{ smallPadding }]">
          <ui-popup-form v-if="!sended">
            <div class="s-30 w-500">{{ header }}</div>
            <div class="s-16 opacity-80">Просто оставьте ваши данные, мы перезвоним</div>
            <div class="form-content">
              <input style="position: absolute; left: -10000px; opacity: 0;" v-model="autor" type="text" class="ui-input" />
              <div v-if="nameview" name="CLIENT_NAME">
                  <input required placeholder="Как Вас зовут" v-model="name" type="text" class="ui-input" />
                </div>
                <div v-if="mailview" name="CLIENT_EMAIL">
                  <input required placeholder="your_email@example.com" type="email" v-model="mail" class="ui-input" />
                </div>
              <input  @focus="errorBorder" v-model="phone" class="ui-input" type="tel" name="CLIENT_PHONE" placeholder="Введите телефон" required />
<!--                <phone-mask-input
                    v-model="phone"
                    v-if="phoneview"
                    name="CLIENT_PHONE"
                    autoDetectCountry
                    @onValidate="onValidate"
                    inputClass="ui-input"
                    placeholder=""
                    required
                />-->
              <textarea v-if="textareaview" :placeholder="textareaplaceholder" v-model="text" rows="5" class="ui-input"></textarea>
                <ui-button @click="sendFeedback()" style="margin-top: 2em;">{{ buttontext }}</ui-button>
            </div>
            <div class="s-12">
              Оставляя Ваш телефон, вы соглашаетесь с <a class="underline" href="/politica/" title="Политика обработки персональных данных">политикой обработки персональных данных</a>
            </div>
          </ui-popup-form>
          <div class="success" v-else>
            <icon-success class="animated zoomIn"></icon-success>
            <div class="s-30 w-500">Заявка отправлена</div>
            <div v-if="subtext" class="s-16">Ожидайте, когда менеджер с вами свяжется</div>
            <ui-button v-if="buttonsuccess" @click="close()">Закрыть окно</ui-button>
          </div>
        </div>
      </transition>
    </div>
</template>

<script>
export default {
  props: {
    smallpadding: {
      type: Boolean,
      default: false
    },
    buttonsuccess: {
      type: Boolean,
      default: true
    },
    sended: {
      type: Boolean,
      default: false
    },
    subtext: {
      type: Boolean,
      default: true
    },
    nameview: {
      type: Boolean,
      default: false
    },
    mailview: {
      type: Boolean,
      default: false
    },
    phoneview: {
      type: Boolean,
      default: false
    },
    textareaview: {
      type: Boolean,
      default: false
    },
    textareaplaceholder: "",
    buttontext: "",
    header: "",
    hiddenHeader: false,
    reachgoaltext: null,
    reachgoaltext2: null,
    eventname: "",
  },
  data() {
    return {
      name: "",
      autor: "",
      mail: "",
      phone: "",
      text: "",
      validPhone: false,
    }
  },
  components: {
    'icon-close': () => import('@/components/icon/icon-close'),
    'icon-success': () => import('@/components/icon/icon-success'),
    'ui-popup-form': () => import('@/components/ui/ui-popup-form'),
    'ui-button': () => import('@/components/ui/ui-button')
  },
  methods: {
    sendFeedback() {

      /*if( (this.phoneview && this.phone=="") || (this.phoneview && !this.validPhone) ){
        this.showError("CLIENT_PHONE");
        return false;
      } else {
        this.hideError("CLIENT_PHONE");
      }*/

      let inputTelVal = this.phone.replace(/^\D+/g, '').replace(/[^0-9]/g, '');
      const PHONE_REGEXP = /^\d+$/;
      const prone = PHONE_REGEXP.test(inputTelVal);
      if( !prone || ( typeof inputTelVal.length === "undefined" ||  inputTelVal.length < 7) ){
        document.querySelector('input[type="tel"]').classList.add('error');
        return false;
      } else {
        document.querySelector('input[type="tel"]').classList.remove('error');
      }

      const EMAIL_REGEXP = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/iu;

      if( (this.mailview && this.mail == "") || (this.mailview && !EMAIL_REGEXP.test(this.mail)) ){
        this.showError("CLIENT_EMAIL");
        return false;
      } else {
        this.hideError("CLIENT_EMAIL");
      }

      if( this.nameview &&  this.name=="" ){
        this.showError("CLIENT_NAME");
        return false;
      } else {
        this.hideError("CLIENT_NAME");
      }

      this.$axios({
        url: '/ajax/?feadback=Y',
        method: 'post',
        params: {
          name: this.name,
          autor: this.autor,
          email: this.email,
          phone: this.phone,
          text: this.text,
          header: ( this.hiddenHeader ) ? this.hiddenHeader : this.header,
          eventname: this.eventname,
          url: location.href
        }
      }).then(response => {
        if (response.status == 200 && response.data.success) {
          if (typeof (ym) === "function") {
            if (this.reachgoaltext) {
              let yaCounterId = this.$store.state.langs.YACOUNTER;
              ym(yaCounterId, 'reachGoal', this.reachgoaltext);
            }
            if (this.reachgoaltext2) {
              let yaCounterId2 = this.$store.state.langs.YACOUNTER2;
              ym(yaCounterId2, 'reachGoal', this.reachgoaltext2);
              ym(yaCounterId2, 'reachGoal', 'all_forms');
            }
          }
          this.sended=true;
          //console.log( "response", response );
        }else{
          console.log('Error feedback success: false')
        }
      }).catch(e => {
        console.log('Error: ' + e)
      })
      //this.loading = false;
    },
    onValidate(ev){
      this.validPhone = !!ev.isValidByLibPhoneNumberJs;
    },
    showError(propertyName) {
      const el = document.getElementsByName(propertyName);
      if (el[0].hasChildNodes) {
        const error = el[0].querySelector(".error-message")
        if (error === null) {
          let div = document.createElement("div")
          div.classList.add("error-message")
          div.append("Заполните это поле")
          el[0].append(div)
          let inp = el[0].querySelector('input');
          inp.classList.add("error")
        }
      }
    },
    hideError(propertyName) {
      const el = document.getElementsByName(propertyName)
      if (el.length > 0) {
        let inp = el[0].querySelector('input');
        inp.classList.remove("error");
        let messageError = el[0].querySelector('.error-message');
        if(messageError) {
          messageError.remove();
        }
      }
    },
    close() {
      //this.$router.push({ hash: undefined })
    },
    errorBorder(){
      const phoneError = document.querySelector('input[type="tel"]');
      if(phoneError) {
        phoneError.classList.remove('error');
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.layout-sent{
  pointer-events: none;
  display: flex;
  & > * {
    pointer-events: all;
  }
  justify-content: center;
  .window{
    text-align: center;
  }
}
[name="CLIENT_EMAIL"], [name="CLIENT_NAME"], [name="CLIENT_PHONE"] {
  position: relative;
}
.overlay {
  background: rgba(50, 59, 83, 0.8);
}
.success {
  svg {
    margin-bottom: 2em;
  }
  .ui-button {
    margin-top: 4em;
  }
}
</style>

<style lang="scss">
.layout-sent {
  .form-content {
    margin: 2.5em 0;
    & > * {
      margin-bottom: 10px;
    }
  }
}
</style>